import { keyframes } from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(359deg);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 0;\n    }\n    to {\n       opacity: 1;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 1;\n    }\n    to {\n       opacity: 0;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    0%  { opacity: 1; }\n    49% { opacity: 1; }\n    50% { opacity: 0; }\n   100% { opacity: 0; }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    0% {\n        transform: translateY(100%);\n    }\n\n    100% {\n        transform: translateY(0%);\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    8%,\n    41% {\n        transform: translateX(calc(",
        " * -10px));\n    }\n    25%,\n    58% {\n        transform: translateX(calc(",
        " * 10px));\n    }\n    75% {\n        transform: translateX(calc(",
        " * -5px));\n    }\n    92% {\n        transform: translateX(calc(",
        " * 5px));\n    }\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n\n    0%{\n        opacity: 0;\n        transform: scale(0.3);\n    }\n    50%{\n        opacity: 0.9;\n        transform: scale(calc(",
        " * 1.1));\n    }\n    80%{\n        opacity: 1;\n        transform: scale(1);\n    }\n    90%{\n        opacity: 1;\n        transform: scale(calc(",
        " * 1.02));\n    }\n    100%{\n        opacity: 1;\n        transform: scale(1);\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n\n    0%{\n        opacity: 1;\n        transform: scale(1);\n    }\n    10%{\n        opacity: 1;\n        transform: scale(calc(",
        " * 1.1));\n    }\n    100%{\n        opacity: 0;\n        transform: scale(0.3);\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n    0% {\n        transform: scale(0);\n    }\n    100% {\n        transform: scale(1);\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n    to {\n       opacity: 1;\n       transform: translateX(0);\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to {\n       opacity: 0;\n       transform: translateX(100%);\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to {\n       opacity: 1;\n       transform: translateX(0);\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n    from {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to {\n       opacity: 0;\n       transform: translateX(-100%);\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
var spinAnimation = function() {
    return keyframes(_templateObject());
};
var fadeInAnimation = function() {
    return keyframes(_templateObject1());
};
var fadeOutAnimation = function() {
    return keyframes(_templateObject2());
};
var blinkAnimation = function() {
    return keyframes(_templateObject3());
};
var climbUpAnimation = function() {
    return keyframes(_templateObject4());
};
var shakeAnimation = function() {
    var magnitude = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return keyframes(_templateObject5(), magnitude, magnitude, magnitude, magnitude);
};
var bounceInAnimation = function() {
    var magnitude = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return keyframes(_templateObject6(), magnitude, magnitude);
};
var bounceOutAnimation = function() {
    var magnitude = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return keyframes(_templateObject7(), magnitude);
};
var scaleUpAnimation = function() {
    return keyframes(_templateObject8());
};
var slideFadeInFromLeftAnimation = function() {
    return keyframes(_templateObject9());
};
var slideFadeOutToRightAnimation = function() {
    return keyframes(_templateObject10());
};
var slideFadeInFromRightAnimation = function() {
    return keyframes(_templateObject11());
};
var slideFadeOutToLeftAnimation = function() {
    return keyframes(_templateObject12());
};

export { blinkAnimation, bounceInAnimation, bounceOutAnimation, climbUpAnimation, fadeInAnimation, fadeOutAnimation, scaleUpAnimation, shakeAnimation, slideFadeInFromLeftAnimation, slideFadeInFromRightAnimation, slideFadeOutToLeftAnimation, slideFadeOutToRightAnimation, spinAnimation };
